import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Button, Label, Alert } from "reactstrap";
import Page from "components/Page";
import { Radiobox, Textbox } from "react-inputs-validation";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FetchDataCarritoHogar, FetchDataCoberturasHogarAdvance, FetchDataSeccionesCoberturasHogar } from "../../redux/actions/ACarritoProductos";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import { CONNREFUSED } from 'dns';
import { setEstadosCiviles } from '../../redux/actions/aCotizacion';
import { obtenerDatosHogar } from '../../utils/validaciones';

class CotizacionConstruccionPaso2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      metrosSelected: "",
      tipoConstruccionSelected: "",
      aniosSelected: "",
      aniosHasError: true,
      datosHogar: obtenerDatosHogar(null),
      pisosSelected: "",
      pisosHasError: true,
      validate: false,
      metrosSelectedError: false,
    };
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }

  onValidateform = async () => {
    let { tipoConstruccionSelected, metrosSelected, aniosSelected, pisosSelected, metrosSelectedError } = this.state;
    this.toggleValidating(true);
    if (aniosSelected !== "" && tipoConstruccionSelected !== "" && pisosSelected !== "" && metrosSelectedError === false) {
      //obtener objetos de tipo de Construcción
      let objTipo = this.props.arrayTiposConstruccion.filter((item) =>
        item.id === tipoConstruccionSelected
      )
      objTipo = objTipo[0];
      //verificar si es el producto actual o es una edidcion
      let codProdActual = this.props.carrito.carCodigoProductoActual
      const queryParams = new URLSearchParams(this.props.location.search);
      const codEdicion = queryParams.get('codEdicion');
      if (codEdicion !== "" && codEdicion !== null) {
        codProdActual = codEdicion
      }
      //Datos a enviar al carrito
      const datosCarrito = {
        empresa: "AIGMETROPOLITANA",
        tipoConstruccion: objTipo,
        AnioConstruccion: aniosSelected,
        pisos: pisosSelected,
        metrosConstruccion: metrosSelected,
        mongoCarrito: this.props.carrito.mongoCarrito,
        pasoCarrito: "seleccionConstruccion",
        codigo: codProdActual
      }
      console.log(JSON.stringify(datosCarrito))
      await this.props.setCarrito(datosCarrito);
      console.log(this.state.datosHogar, 'HOGAR ssssssssssssssss');
      if (this.props.carritoload.carritoHogarError === false) {
        const queryParams = new URLSearchParams(this.props.location.search);
        const codEdicion = queryParams.get('codEdicion');
        if (codEdicion === '' || codEdicion === null) {



          let datosCarritoHogar =
          {
            "empresa": "AIGMETROPOLITANA",
            "idCarrito": this.props.carrito.mongoCarrito
          }
          await this.props.cargarSeccionesCoberturas(datosCarritoHogar);

          if (this.state.datosHogar.codigo !== 'hogar-aig') {
            //Redireccionar paso 3
            this.props.history.push(
              {
                pathname:'/cotizacion-hogar-paso3',
                search: this.state.datosHogar.codigo != null
                  ? "?producto=" + this.state.datosHogar.codigo
                  : "",
              }
            );
          }

          if (this.state.datosHogar.codigo === 'hogar-aig') {
            let codProductoActual = this.props.carrito.carCodigoProductoActual
            if (codEdicion !== undefined && codEdicion !== '' && codEdicion !== null) {
              codProductoActual = codEdicion
            }
            const datosCarritoProtecciones = {
              empresa: "AIGMETROPOLITANA",
              protecciones: [],
              mongoCarrito: this.props.carrito.mongoCarrito,
              pasoCarrito: "protecciones",
              codigo: codProductoActual
            }
            await this.props.cargarCoberturasHogarAdvance();
            await this.props.setCarrito(datosCarritoProtecciones);

            let datosCarritoHogar = {
              "empresa": "AIGMETROPOLITANA",
              "idCarrito": this.props.carrito.mongoCarrito
            }
            await this.props.cargarSeccionesCoberturas(datosCarritoHogar);

            this.props.history.push(
              {
                 pathname: "/cotizacion-hogar-paso4",
                 search: this.state.datosHogar.codigo != null
                  ? "?producto=" + this.state.datosHogar.codigo
                  : "",
              }
            );
          }

        }
        else {
          if (this.state.datosHogar.codigo !== 'hogar-aig') {
            this.props.history.push({ pathname: '/cotizacion-hogar-paso3', search: `codEdicion=${codEdicion}${this.state.datosHogar.codigo != null? "&producto=" + this.state.datosHogar.codigo: ""}` });
          }

          if (this.state.datosHogar.codigo === 'hogar-aig') {
            this.props.history.push({ 
              pathname: "/cotizacion-hogar-paso4", 
              search: `codEdicion=${codEdicion}${this.state.datosHogar.codigo != null ? "&producto=" + this.state.datosHogar.codigo : ""}` 
            });
            return null;
          }
        }

      }

    }
  }

  onRegresar = async () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const codEdicion = queryParams.get('codEdicion');
    if (codEdicion === "" || codEdicion === null) {
      //Redireccionar a datos del contratante cuando es la primera ubicacion
      this.props.history.push({
        pathname: "/cotizacion-hogar",
        search: this.state.datosHogar.codigo != null
          ? "?producto=" + this.state.datosHogar.codigo
          : "",
      });
    }
    else {
      this.props.history.push({
        pathname: "/cotizacion-hogar",
        search: `codEdicion=${codEdicion}${this.state.datosHogar.codigo != null ? "&producto=" + this.state.datosHogar.codigo : ""}`, //agregar parametros de la url,
      });
    }

  }

  async componentDidMount() {


    let producto = null
    let seguro = this.props.carrito.carDescripcionSeguro;

    switch (seguro) {
      case 'HOGAR AIG':
        producto = 'hogar-aig'
        break;

      case 'HOGAR ADVANCE':
        producto = 'advance'
        break;

      default:
        break;
    }

    this.setState({ datosHogar: obtenerDatosHogar(producto) })

    this.cargarDatosBack();

  }

  cargarDatosBack() {
    if (this.props.carrito && this.props.carrito.carProductos) {
      const queryParams = new URLSearchParams(this.props.location.search);
      const codEdicion = queryParams.get('codEdicion');
      let codProductoActual = this.props.carrito.carCodigoProductoActual
      if (codEdicion !== undefined && codEdicion !== "" && codEdicion !== null) {
        codProductoActual = codEdicion
      }
      //Obtener Producto actual
      let ObtenerProductoActual = this.props.carrito.carProductos.filter((item) =>
        item.codigo === codProductoActual
      )
      ObtenerProductoActual = ObtenerProductoActual[0];
      if (ObtenerProductoActual && ObtenerProductoActual !== '' && ObtenerProductoActual.datosConstruccion) {
        this.setState({
          tipoConstruccionSelected: ObtenerProductoActual.datosConstruccion.tipoConstruccion.id,
          metrosSelected: ObtenerProductoActual.datosConstruccion.metrosConstruccion,
          aniosSelected: ObtenerProductoActual.datosConstruccion.AnioConstruccion,
          pisosSelected: ObtenerProductoActual.datosConstruccion.pisos,
          pisosHasError: false,
          aniosHasError: false,
        })
      }
    }
  }

  render() {
    let { validate, metrosSelected, aniosSelected, tipoConstruccionSelected, aniosHasError, pisosSelected, pisosHasError } = this.state;
    return (
      <LoadingScreen
        loading={this.props.carritoload.carritoHogarloading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Cargando..."
      >
        <Page title={this.state.datosHogar.titulo} breadcrumbs={[{ name: this.state.datosHogar.titulo, active: true }]}>

          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>
          <Row>
            <Col md={12} className="mb-3">
              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }} className='mb-5'>Datos de la Construcción</h4>
                  <Row>
                    <Col lg={2}></Col>
                    <Col lg={8} md={12} sm={12} xs={12}>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Tipo de Construcción</Label></h5></Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                          <Radiobox
                            //tabIndex={2} // Optional.[String or Number].Default: none.
                            id="anios" // Optional.[String].Default: "".  Input ID.
                            name="anios" // Optional.[String].Default: "". Input name.
                            value={tipoConstruccionSelected} // Optional.[String].Default: "".
                            optionList={this.props.arrayTiposConstruccion}
                            customStyleContainer={{
                              display: 'block',
                              justifyContent: 'flex-start'
                            }} // Optional.[Object].Default: {}.
                            customStyleOptionListItem={{ marginRight: '20px' }} // Optional.[Object].Default: {}.
                            onChange={(job, e) => {
                              this.setState({ tipoConstruccionSelected: job });

                            }} // Required.[Func].Default: () => {}. Will return the value.
                            onBlur={(e) => { console.log(e) }} // Optional.[Func].Default: none.
                            validate={validate}
                            validationCallback={res => this.setState({ validate: res })} // Optional.[Func].Default: none. Return the validation result.
                            validationOption={{
                              name: 'Tipo de Construcción', // Optional.[String].Default: "". To display in the Error message. i.e Please enter your .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              msgOnError: "Por especifíque el tipo de construcción de la vivienda."
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2}></Col>
                  </Row>

                  <Row>
                    <Col lg={2}></Col>
                    <Col lg={8} md={12} sm={12} xs={12}>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Especifíque los metros cuadrados (m2) de construcción de la vivienda</Label></h5></Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                          <Textbox
                            tabIndex="1"
                            type="input"
                            value={metrosSelected}
                            name="metros"
                            id="metros"
                            placeholder="Especifique los m2 de la construcción."
                            classNameInput={"form-control"}
                            onChange={(metros, e) => {
                              this.setState({ metrosSelected: metros });
                            }}
                            validate={validate}
                            validationCallback={res => this.setState({ validate: !res, metrosSelectedError: res })} // Optional.[Func].Default: none. Return the validation result.
                            onBlur={e => this.setState({ blur: true })}
                            // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            validationOption={{
                              name: "Metros de Construcción", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: false,
                              reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.
                              msgOnError: "El valor ingresado debe estar en el siguiente formato, ejemplo (1800.30)" // Optional.[Bool].Default: true. To determin if it is a required field.
                            }}

                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2}></Col>
                  </Row>

                  <Row>
                    <Col lg={2}></Col>
                    <Col lg={8} md={12} sm={12} xs={12}>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Año de construcción de la vivienda.</Label></h5></Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                          <Select
                            value={aniosSelected}
                            components={makeAnimated()}
                            onChange={(anios, e) => {
                              this.setState({
                                aniosSelected: anios,
                                aniosHasError: false
                              });
                            }}
                            options={this.props.arrayAnios}
                            isSearchable={true}
                            placeholder={"Seleccione el año de construcción de la vivienda"}
                            isMulti={false}
                          />
                          {aniosHasError &&
                            <span style={{ color: "red", fontSize: "1rem" }}>Por favor seleccione el año de construcción de la vivienda.</span>
                          }
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2}></Col>
                  </Row>

                  <Row>
                    <Col lg={2}></Col>
                    <Col lg={8} md={12} sm={12} xs={12}>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Número total de pisos del edificio o casa.</Label></h5></Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                          <Select
                            value={pisosSelected}
                            components={makeAnimated()}
                            onChange={(pisos, e) => {
                              this.setState({
                                pisosSelected: pisos,
                                pisosHasError: false
                              });
                            }}
                            options={this.props.arrayPisos}
                            isSearchable={true}
                            placeholder={"Seleccione el número total de pisos del edificio o casa"}
                            isMulti={false}
                          />
                          {pisosHasError &&
                            <span style={{ color: "red", fontSize: "1rem" }}>Por favor seleccione el número de pisos de la vivienda.</span>
                          }
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2}></Col>
                  </Row>

                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div style={{ textAlign: "center" }}>
                        <Button className={"button-white"} onClick={this.onRegresar}>
                          <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                          REGRESAR
                        </Button>
                        {"   "}
                        <Button onClick={this.onValidateform} className="btn btn-primary" >
                          <i className="fa fa-chevron-circle-right" aria-hidden="true" />{` CONTINUAR`}
                        </Button>
                        <p></p>
                        {this.props.carritoload.carritoHogarError && this.props.carritoload.carritoHogarError &&
                          <Alert color="danger" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
                            <center><p>Ha ocurrido un inconveniente al guardar la información. Por favor intente nuevamente.</p></center>
                          </Alert>
                        }
                      </div>
                    </Col>
                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>


        </Page>
      </LoadingScreen>
    );
  }

};

const mapStateToProps = state => ({
  arrayAnios: state.catalogosHogar.setRelatividadesHogar.aniosConstruccionValue,
  arrayPisos: state.catalogosHogar.setRelatividadesHogar.pisosConstruccionValue,
  arrayTiposConstruccion: state.catalogosHogar.setRelatividadesHogar.tiposConstruccion,
  carrito: state.datosCarritoHogar.setCarritoHogar,
  carritoload: state.datosCarritoHogar
});

const mapDispatchToProps = dispatch => {
  return {
    setCarrito: (datosCarrito) => dispatch(FetchDataCarritoHogar(datosCarrito)),
    cargarSeccionesCoberturas: (param) => dispatch(FetchDataSeccionesCoberturasHogar(param)),
    cargarCoberturasHogarAdvance: () => dispatch(FetchDataCoberturasHogarAdvance()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionConstruccionPaso2)
);
